import { IDespesaFullDTO } from '../../../../models/happy-code-api.model';
import { useNotificationService } from '../../../../services/notification.service';

export default function useValidationFormDespesa() {
	const notification = useNotificationService();
	const validateFields = (despesa: IDespesaFullDTO, id?: number) => {
		switch (true) {
      case !despesa?.conta?.id:
         notification({
          description: 'Por favor, preencha a conta',
          type: 'warning',
          message: 'Aviso!',
      })
      return false
			case !despesa?.fornecedor?.id:
				 notification({
					description: 'Por favor, preencha o fornecedor',
					type: 'warning',
					message: 'Aviso!',
				});
        return false
			case !despesa?.dhCompetencia:
				 notification({
					description: 'Por favor, preencha a data de competência',
					type: 'warning',
					message: 'Aviso!',
				});
        return false
			case !despesa?.dsDespesa:
				 notification({
					description: 'Por favor, preencha a descrição da despesa',
					type: 'warning',
					message: 'Aviso!',
				});
        return false
			case despesa?.tpParcelamento === 'Parcelado' && !despesa.parcelamentoDto?.qtdRepetir && !id:
				 notification({ description: 'Por favor, informe o número de parcelas', type: 'warning', message: 'Aviso!' });
         return false;

			case despesa?.tpParcelamento === 'Parcelado' && !despesa.parcelamentoDto?.qtdFrequencia && !id:
				 notification({ description: 'Por favor, selecione o intervalo entre parcelas', type: 'warning', message: 'Aviso!' });
         return false;
			case !despesa?.vlDespesa:
				notification({
					description: 'Por favor, preencha o valor da despesa',
					type: 'warning',
					message: 'Aviso!',
				});
				return false;
			case !despesa?.centroCusto?.id:
				notification({
					description: 'Por favor, preencha o centro de custo',
					type: 'warning',
					message: 'Aviso!',
				});
				return false;
			case !despesa?.categoria?.id:
				notification({
					description: 'Por favor, preencha a categoria',
					type: 'warning',
					message: 'Aviso!',
				});
				return false;
			case !despesa?.subCategoria?.id:
				notification({
					description: 'Por favor, preencha a subcategoria',
					type: 'warning',
					message: 'Aviso!',
				});
				return false;
			case !despesa?.tpCusto:
				notification({
					description: 'Por favor, selecione o tipo de custo',
					type: 'warning',
					message: 'Aviso!',
				});
				return false;
			case !despesa?.tpParcelamento:
				notification({
					description: 'Por favor, selecione o tipo de pagamento (à vista ou parcelado)',
					type: 'warning',
					message: 'Aviso!',
				});
				return false;
				case !despesa?.tipoPagamento?.id:
					notification({
						description: 'Por favor, selecione a forma de pagamento',
						type: 'warning',
						message: 'Aviso!',
					});
					return false
			case !despesa?.dhVencimento:
				notification({
					description: 'Por favor, selecione a data de vencimento',
					type: 'warning',
					message: 'Aviso!',
				});
				return false;
			case despesa?.flPago && !despesa?.vlPago:
				notification({
					description: 'Por favor, preencha o valor pago',
					type: 'warning',
					message: 'Aviso!',
				});
				return false;
			case despesa?.flPago && !despesa?.dhPagamento:
				notification({
					description: 'Por favor, preencha a data de pagamento',
					type: 'warning',
					message: 'Aviso!',
				});
				return false;
				case despesa?.flPago && despesa?.vlPago > despesa?.vlDespesa:
				notification({
					description: 'O valor pago nao pode ser maior que o valor da despesa',
					type: 'warning',
					message: 'Aviso!',
				})
				return false
			default:
				return true;
		}
	};
	return validateFields;
}
